// Thin wrappers around the Opinly analytics pixel (loaded in __root.tsx).
// Safe no-ops during SSR or before the script has loaded.
type TrackOptions = { externalEventId?: string; email?: string };

type OpinlyPixel = {
  anonId?: string;
  identify?: (traits: { email?: string; userId?: string } & Record<string, unknown>) => void;
  track?: (event: string, properties?: Record<string, unknown>, options?: TrackOptions) => void;
};

function pixel(): OpinlyPixel | null {
  if (typeof window === "undefined") return null;
  return (window as unknown as { opinly?: OpinlyPixel }).opinly ?? null;
}

/** Anonymous visitor id — pass to the server so server-side events attribute correctly. */
export function opinlyAnonId(): string | null {
  try {
    return pixel()?.anonId ?? null;
  } catch {
    return null;
  }
}

export function opinlyIdentify(traits: { email?: string; userId?: string } & Record<string, unknown>) {
  try {
    pixel()?.identify?.(traits);
  } catch {}
}

export function opinlyTrack(
  event: string,
  properties?: Record<string, unknown>,
  options?: TrackOptions,
) {
  try {
    pixel()?.track?.(event, properties, options);
  } catch {}
}
